// utils/customTheme.ts

import { ThemeConfig, theme } from "antd";

export const lightTheme: ThemeConfig = {
  algorithm: theme.defaultAlgorithm,
};
